import Box from "@/common/components/Box";
import NegotiatingProductItemShow from "./NegotiatingProductItem";
import { NegotiationProductData } from "../../types/negotiations.type";
import { CompanyData } from "@/features/privateCompanies/types/companies.type";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";

interface NegotiatingProductsShowProps {
  negotiationProducts?: NegotiationProductData[];
  clientCompany?: CompanyData;
  establishment?: EstablishmentCompanyData;
}

const NegotiatingProductsShow = ({ negotiationProducts, clientCompany, establishment }: NegotiatingProductsShowProps) => {
  return (
    <Box className="flex flex-col gap-4">
      <p>Produtos em negociação</p>

      {negotiationProducts?.map((negotiationProduct, index) => (
        <NegotiatingProductItemShow
          key={negotiationProduct.id}
          index={index}
          negotiationProduct={negotiationProduct}
          clientCompany={clientCompany}
          establishment={establishment}
        />
      ))}
    </Box>
  );
};

export default NegotiatingProductsShow;
